import { useState, useEffect, useCallback } from "react";
import { AvailableProvider } from "../types";
import { sanitizeProviders } from "../utils/providerDataTransformers";

export function useProviderData(
  externalAvailableProviders?: AvailableProvider[],
) {
  const [providers, setProviders] = useState<AvailableProvider[]>([]);

  const updateProviders = useCallback(() => {
    const sanitized = sanitizeProviders(externalAvailableProviders);
    setProviders(sanitized);
  }, [externalAvailableProviders]);

  useEffect(() => {
    updateProviders();
  }, [updateProviders]);

  return providers;
}
